import React from "react";

const StudentsHero = ({ data }) => (

    <section className="students-hero">

        <div className="container">

            <span className="students-eyebrow">
                {data.eyebrow}
            </span>

            <h1>
                {data.title}{" "}
                <span>{data.highlight}</span>
            </h1>

            <p className="students-hero-description">
                {data.description}
            </p>

        </div>

    </section>
);

export default StudentsHero;